
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Scholorship</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm rgi-scholarship section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col">
                <div class="sec-title text-center">
                    <h2> Meritorius Scholarship<span> Policy 2021-2023 </span>
                    </h2>
                </div>
                <div class="widget_title inner-title mt-3">
                    <h4>[A] FOR ALL UG COURSES [BCOM, BBA, BCA, BCCA, BA, BSC-IT, FORENSIC, HOSPITALITY, FIRE, NURSING & ALL OTHER BSC COURSES]</h4>
                </div>
                <div class="table-responsive">
                    <table class="table table-hover table-striped table-effect--primary shadow-soft">
                        <thead class="head-table">
                            <tr>
                                <th rowspan="3">Eligible Minimum % at qualifying examination level</th>
                                <th class="text-center" colspan="3">Fee Scholarship in % of Applicable Fees</th>
                            </tr>
                            <tr>
                                <th>Aggregate Score 85%-89.99%</th>
                                <th>Aggregate Score 90%-94.99%</th>
                                <th>Aggregate Score More than 95%</th>
                            </tr>
                        </thead>
                        <tbody class="tb-hover">
                            <tr>
                                <td>85% Marks</td>
                                <td>5%</td>
                                <td>10%</td>
                                <td>15%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="widget_title inner-title mt-3">
            <h4>[B] For Engineering & LLB Constituents</h4>
        </div>
        <h4></h4>
        <div class="table-responsive">
            <table class="table table-hover table-striped table-effect--primary shadow-soft">
                <thead class="head-table">
                    <tr>
                        <th rowspan="3" width="38%">Discipline</th>
                        <th rowspan="3" width="22%">Eligible Minimum PCM at qualifying examination level</th>
                        <th colspan="3" width="40%">Fee Scholarship in % of Applicable Fees</th>
                    </tr>
                    <tr>
                        <th>PCM Score 70%-79.99%</th>
                        <th>PCM Score 80%-89.99%</th>
                        <th>PCM Score More than 90%</th>
                    </tr>
                </thead>
                <tbody class="tb-hover">
                    <tr>
                        <td>Computer Science &amp; Engineering, Information Technology, Artificial Intelligence, Data Science and all other emerging engineering disciplines</td>
                        <td>80% Marks</td>
                        <td>--</td>
                        <td>5%</td>
                        <td>10%</td>
                    </tr>
                    <tr>
                        <td>All Other Engineering disciplines [including Electrical, Civil, Mechanical, Electronics/ETC] *</td>
                        <td>80% Marks</td>
                        <td>--</td>
                        <td>10%</td>
                        <td>15%</td>
                    </tr>
                    <tr>
                        <td>L.L.B. [For integrated course of 5 years]</td>
                        <td>70% Marks</td>
                        <td>5%</td>
                        <td>10%</td>
                        <td>15%</td>
                    </tr>
                    <tr>
                        <td>L.L.B. [3 years]</td>
                        <td>Graduation level marks 80%</td>
                        <td>--</td>
                        <td>10%</td>
                        <td>15%</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="widget_title inner-title mt-3">
                * Book Bank scheme for these students from caution money paid in first year. Returnable basis after one year. This scheme will be applicable from 1st year.
                <h4>[C] FOR ENGINEERING DIRECT SECOND YEAR CONSTITUENTS</h4>

                <div class="table-responsive">
                    <table class="table table-hover table-striped table-effect--primary shadow-soft">
                        <thead class="head-table">
                            <tr>
                                <th>Discipline</th>
                                <th>Eligible Minimum % at qualifying examination level</th>
                                <th>Fee Scholarship in % of Applicable Fees</th>
                            </tr>
                        </thead>
                        <tbody class="tb-hover">
                            <tr>
                                <td>Computer Science & Engineering, Information Technology, Artificial Intelligence, Data Science and all other emerging engineering disciplines [Nagpur Campuses]</td>
                                <td>85% Marks</td>
                                <td>5%</td>
                            </tr>
                            <tr>
                                <td>All Other Engineering disciplines [including Electrical, Civil, Mechanical, Electronics/ETC] - [Nagpur Campuses]</td>
                                <td>75% Marks</td>
                                <td>10%</td>
                            </tr>

                            <tr>
                                <td>All Engineering disciplines at Jalgaon, Pune Campuses & GHRU Saikheda & Amravati</td>
                                <td>70%</td>
                                <td>10%</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="widget_title inner-title mt-3">
                        <h4>[ For MBA, M.Sc. (All), LLM & MCA Courses</h4>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-hover table-striped table-effect--primary shadow-soft">
                            <thead class="head-table">
                                <tr>
                                    <th rowspan="2">Eligible Minimum % at qualifying examination level</th>
                                    <th colspan="2">Fee Scholarship in % of Applicable Fees</th>
                                </tr>
                                <tr>
                                    <th>Qualifying Score 70%-79.99%</th>
                                    <th>Qualifying Score Above 80%</th>
                                </tr>
                            </thead>
                            <tbody class="tb-hover">
                                <tr>
                                    <td>70% Marks</td>
                                    <td>10%</td>
                                    <td>15%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="widget_title inner-title mt-3">
                        <h4>[E] For Commerce Class XI [CBSE & State]</h4>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-hover table-striped table-effect--primary shadow-soft">
                            <thead class="head-table">
                                <tr>
                                    <th rowspan="2">Eligible Minimum % at qualifying examination level</th>
                                    <th colspan="2">Fee Scholarship in % of Applicable Fees</th>
                                </tr>
                                <tr>
                                    <th>Aggregate Score 85%-89.99%</th>
                                    <th>Aggregate Score More than 90%</th>
                                </tr>
                            </thead>
                            <tbody class="tb-hover">
                                <tr>
                                    <td>85% Marks</td>
                                    <td>10%</td>
                                    <td>15%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="widget_title inner-title mt-3">
                        <h4>[F] For Pharmacy & B.Sc. Agriculture</h4>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-hover table-striped table-effect--primary shadow-soft">
                            <thead class="head-table">
                                <tr>
                                    <th rowspan="2">Discipline</th>
                                    <th rowspan="2">Eligible Minimum PCM at qualifying examination level</th>
                                    <th colspan="2">Fee Scholarship in % of Applicable Fees</th>
                                </tr>
                                <tr>
                                    <th>PCM Score 80%-89.99%</th>
                                    <th>PCM Score More than 90%</th>
                                </tr>
                            </thead>
                            <tbody class="tb-hover">
                                <tr>
                                    <td>Pharmacy D. Pharm., B. Pharm.</td>
                                    <td>80% Marks</td>
                                    <td>5%</td>
                                    <td>10%</td>
                                </tr>
                                <tr>
                                    <td>B.Sc. Agriculture</td>
                                    <td>80%</td>
                                    <td>5%</td>
                                    <td>10%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="widget_title inner-title mt-3">
                        <h4>[G] For granting concession to the Wards & Siblings admitted in RGI Institutes 2021-22</h4>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-hover table-striped table-effect--primary shadow-soft">
                            <thead class="head-table">
                                <tr>
                                    <th>S. No.</th>
                                    <th>Program</th>
                                    <th>
                                        Ward of Existing employee <br />
                                        # [Tuition fees + Development Fees]
                                    </th>
                                    <th>
                                        Sibling ##<br />
                                        [Tuition fees + Development Fees]
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="tb-hover cust_ser_num">
                                <tr>
                                    <td>1</td>
                                    <td>B.E.-I Year</td>
                                    <td>50%</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>B.E.-DSY</td>
                                    <td>50%</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>MTech/ME</td>
                                    <td colspan="2">Fees as per Last year</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Polytechnic</td>
                                    <td>50%</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>MBA</td>
                                    <td>50%</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>MCA</td>
                                    <td>50%</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>Law</td>
                                    <td>50%</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>8</td>
                                    <td>Schools</td>
                                    <td>50%</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>9</td>
                                    <td>Others</td>
                                    <td>50%</td>
                                    <td>5%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <ul class="list-style list-style1">
                        <li>
                            Wards # of Employee having 2 years of continuous service at RGI as on 31st May 2021 are eligible for concession. In case of discontinuation of employee by the management, 25% concession will be applicable to the
                            student.
                        </li>
                        <li>The Sibling ## concession will get the privilege of this scheme till his elder sibling is studying in the institution.</li>
                        <li>The above Scholarship will continue in subsequent years if the student clears previous semester/year examination in one attempt.</li>
                    </ul>
                    <br />

                    <div class="widget_title inner-title mt-3">
                        <h4>[H] For granting concession to the students studying in RGI Institutes 2021-22</h4>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-hover table-striped table-effect--primary shadow-soft">
                            <thead class="head-table">
                                <tr>
                                    <th>S. No.</th>
                                    <th>Program</th>
                                    <th>
                                        Student of RGI institutes <br />
                                        # [Tuition fees + Development Fees]
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="tb-hover cust_ser_num">
                                <tr>
                                    <td>1</td>
                                    <td>B.E.-I Year</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>B.E.-DSY</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>MTech/ME</td>
                                    <td>Fees as per Last year</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Polytechnic</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>MBA</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>MCA</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>Law</td>
                                    <td>5%</td>
                                </tr>
                                <tr>
                                    <td>8</td>
                                    <td>Schools</td>
                                    <td>NA</td>
                                </tr>
                                <tr>
                                    <td>9</td>
                                    <td>Others</td>
                                    <td>5%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="widget_title inner-title mt-3">
                        <h4>[I] Sports &amp; Disability Scholarship Policy</h4>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-hover table-striped table-effect--primary shadow-soft">
                            <thead class="head-table">
                                <tr>
                                    <th>Participation in Sports</th>
                                    <th>% of Scholarship offered</th>
                                </tr>
                            </thead>
                            <tbody class="tb-hover">
                                <tr>
                                    <td>State level</td>
                                    <td>10%</td>
                                </tr>
                                <tr>
                                    <td>National level</td>
                                    <td>15%</td>
                                </tr>
                                <tr>
                                    <td>International level</td>
                                    <td>20%</td>
                                </tr>
                                <tr>
                                    <td>For Physically disabled</td>
                                    <td>The amount of Scholarship shall be decided by the committee on the basis of level of physical disability</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="widget_title inner-title mt-3">
                        <h4>Note:</h4>
                    </div>
                    <ul class="list-style list-style1">
                        <li>All schemes are applicable at Entry Level only except for Wards of existing employees and siblings [G]</li>
                        <li>The Scholarship amount will be calculated on the basis of applicable fees [Tuition fees + Development Fees], payable by the student as per category.</li>
                        <li>The maximum number of instalments will be two (2). Deduction of concession will be done in the last (2nd) instalment.</li>
                        <li>The scholarship will not be received in Cash. The same will be adjusted in their annual fees.</li>
                        <li>Fee defaulters will not be eligible for scholarship.</li>
                        <li>Student can avail only one scholarship at a time.</li>
                        <li>In case of readmission in any course the student has to pay 50% of the applicable fees in case he has paid full fees earlier.</li>
                        <li>All Scholarships are at the sole discretion of the Management and the Policy is subject to change intermittently.</li>
                    </ul>
                </div>
        </div>
    </div>
</section>

